import deviceGroup from './deviceGroup'
import egro from './egro.json'

export default {
  translation: {
    deviceGroup,
    egro,
  },
}
